

import { useQuery } from "@tanstack/react-query";
import type { OrderPaymentProofUrlResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreOrderProofQueryParams = {
  storeId: string;
  orderId: string;
};

export function useStoreOrderProofQuery({
  storeId,
  orderId,
}: UseStoreOrderProofQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeOrderProof(storeId, orderId),
    queryFn: () =>
      apiJsonClient<OrderPaymentProofUrlResponse>(
        endpoints.admin.storeOrderProof(storeId, orderId),
      ),
    enabled: storeId.length > 0 && orderId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
